import { bindPrototypeMethodsToSelf } from '@wix/panorama-common/utils';
export class PanoramaPhaseImpl {
  constructor(name, baseClient) {
    this.name = name;
    this.baseClient = baseClient;
    this.baseClient = baseClient;
    bindPrototypeMethodsToSelf(this);
  }
  start(data) {
    return this.baseClient.reportPhaseStart(this.name, data);
  }
  finish(data) {
    return this.baseClient.reportPhaseFinish(this.name, data);
  }
}
//# sourceMappingURL=panorama-phase.js.map